import React from "react";
import AnalyticsChart from "../components/AnalyticsChart";
import usePageMeta from "../utils/usePageMeta";

const Analytics = () => {
  usePageMeta({
    title: "Draw analytics",
    description:
      "Digit frequency for California Daily 3 and Daily 4, computed from published results and plotted against what a fair draw would produce.",
    path: "/analytics",
  });

  return (
  <div className="page analytics">
    <h1>Draw analytics</h1>
    <p>
      Digit frequency from published California Lottery results, plotted against what
      a fair draw would produce. Every chart below is computed from real draws — no
      example data, and no predictions.
    </p>

    <div className="grid" style={{ gridTemplateColumns: "1fr" }}>
      <AnalyticsChart game="Daily3" />
      <AnalyticsChart game="Daily4" />
    </div>

    <section className="prose">
      <h2>How to read these</h2>
      <p>
        The dashed line is the count each digit would land on if every digit were
        equally likely — total digits divided by ten. Bars wander above and below it
        in any real sample; that scatter is what randomness looks like, and it
        shrinks as a proportion as more draws accumulate.
      </p>
      <p>
        A digit sitting above the line has not become “due”, and one below it has not
        become “hot”. Each draw is independent, so past frequency carries no
        information about the next result.
      </p>
    </section>
  </div>
);
};

export default Analytics;
